export class ConfigOptions {
    private defaultPath = 'config/config.json';
    public configPath: string = window["rootPath"] ? window["rootPath"] + this.defaultPath : this.defaultPath;
    public loadValidationPlugin: boolean = true;
}